import type { LucideIcon } from 'lucide-react';
import { Btn, SectionHeading, UpgradePrompt } from '../ui';
import { c } from '../../styles/theme';

export interface VerifiedAccessLockedStateProps {
  title: string;
  subtitle: string;
  description: string;
  icon: LucideIcon;
  onUpgrade: () => void;
}

/**
 * In-place locked state for signed-in accounts that are not yet verified for app access.
 *
 * Matches the existing route-level lock pattern: keep the destination's own heading and
 * layout, replace only the content with an upsell-style explanation and one route out.
 */
export default function VerifiedAccessLockedState({
  title,
  subtitle,
  description,
  icon: Icon,
  onUpgrade,
}: VerifiedAccessLockedStateProps) {
  return (
    <div>
      <SectionHeading
        as="h1"
        icon={<Icon size={17} color={c.accent} />}
        title={title}
        subtitle={subtitle}
        marginBottom={18}
      />
      <UpgradePrompt
        paddingY={28}
        icon={<Icon size={28} color={c.text3} />}
        title={`${title} requires a verified account`}
        description={description}
        action={<Btn onClick={onUpgrade}>Go to Upgrade</Btn>}
      />
    </div>
  );
}
